/* eslint-disable */
// This file was copied from https://github.com/minervaproject/json0 on September 4, 2025.
// It was originally a fork of https://github.com/ot-types/json0.
// Original file and comments from original author below:
// --------------------

/*
 This is the implementation of the JSON OT type.

 Spec is here: https://github.com/josephg/ShareJS/wiki/JSON-Operations

 Note: This is being made obsolete. It will soon be replaced by the JSON2 type.
*/

import { bootstrapTransform } from "./bootstrapTransform";

/**
 * UTILITY FUNCTIONS
 */

/**
 * Checks if the passed object is an Array instance. Can't use Array.isArray
 * yet because its not supported on IE8.
 *
 * @param obj
 * @returns {boolean}
 */
const isArray = function (obj) {
  return Object.prototype.toString.call(obj) == "[object Array]";
};

/**
 * Checks if the passed object is an Object instance.
 * No function call (fast) version
 *
 * @param obj
 * @returns {boolean}
 */
const isObject = function (obj) {
  return !!obj && obj.constructor === Object;
};

/**
 * Clones the passed object using JSON serialization (which is slow).
 *
 * hax, copied from test/types/json. Apparently this is still the fastest way
 * to deep clone an object, assuming we have browser support for JSON.  @see
 * http://jsperf.com/cloning-an-object/12
 */
const clone = function (o) {
  return JSON.parse(JSON.stringify(o));
};

/**
 * JSON OT Type
 * @type {*}
 */
const json: any = {
  name: "json0",
  uri: "http://sharejs.org/types/JSONv0",
};

// You can register another OT type as a subtype in a JSON document using
// the following function. This allows another type to handle certain
// operations instead of the builtin JSON type.
const subtypes = {};
json.registerSubtype = function (subtype) {
  subtypes[subtype.name] = subtype;
};

json.create = function (data) {
  // Null instead of undefined if you don't pass an argument.
  return data === undefined ? null : clone(data);
};

json.invertComponent = function (c) {
  const c_ = { p: c.p } as any;

  // handle subtype ops
  if (c.t && subtypes[c.t]) {
    c_.t = c.t;
    c_.o = subtypes[c.t].invert(c.o);
  }

  if (c.si !== void 0) c_.sd = c.si;
  if (c.sd !== void 0) c_.si = c.sd;
  if (c.oi !== void 0) c_.od = c.oi;
  if (c.od !== void 0) c_.oi = c.od;
  // **** START CUSTOM CHANGE ****
  // oid (object insert default) inverts to od, assuming the insert happened
  if (c.oid !== void 0) c_.od = c.oid;
  // **** END CUSTOM CHANGE ****
  if (c.li !== void 0) c_.ld = c.li;
  if (c.ld !== void 0) c_.li = c.ld;
  if (c.na !== void 0) c_.na = -c.na;

  if (c.lm !== void 0) {
    c_.lm = c.p[c.p.length - 1];
    c_.p = c.p.slice(0, c.p.length - 1).concat([c.lm]);
  }

  return c_;
};

json.invert = function (op) {
  const op_ = op.slice().reverse();
  const iop = [];
  for (let i = 0; i < op_.length; i++) {
    iop.push(json.invertComponent(op_[i]));
  }
  return iop;
};

json.checkValidOp = function (op) {
  for (let i = 0; i < op.length; i++) {
    if (!isArray(op[i].p)) throw new Error("Missing path");
  }
};

json.checkList = function (elem) {
  if (!isArray(elem)) throw new Error("Referenced element not a list");
};

json.checkObj = function (elem) {
  if (!isObject(elem)) {
    throw new Error(`Referenced element not an object (it was ${JSON.stringify(elem)})`);
  }
};

// helper functions to convert old string ops to and from subtype ops
function convertFromText(c) {
  c.t = "text0";
  const o = { p: c.p.pop() } as any;
  if (c.si != null) o.i = c.si;
  if (c.sd != null) o.d = c.sd;
  c.o = [o];
}

function convertToText(c) {
  c.p.push(c.o[0].p);
  if (c.o[0].i != null) c.si = c.o[0].i;
  if (c.o[0].d != null) c.sd = c.o[0].d;
  delete c.t;
  delete c.o;
}

json.apply = function (snapshot, op) {
  json.checkValidOp(op);

  op = clone(op);

  const container = {
    data: snapshot,
  };

  for (let i = 0; i < op.length; i++) {
    const c = op[i];

    // convert old string ops to use subtype for backwards compatibility
    if (c.si != null || c.sd != null) convertFromText(c);

    let parent = null;
    let parentKey = null;
    let elem = container;
    let key = "data";

    for (let j = 0; j < c.p.length; j++) {
      const p = c.p[j];

      parent = elem;
      parentKey = key;
      elem = elem[key];
      key = p;

      if (parent == null) throw new Error("Path invalid");
    }

    // handle subtype ops
    if (c.t && c.o !== void 0 && subtypes[c.t]) {
      elem[key] = subtypes[c.t].apply(elem[key], c.o);

      // Number add
    } else if (c.na !== void 0) {
      if (typeof elem[key] !== "number") throw new Error("Referenced element not a number");

      elem[key] += c.na;
    }

    // List replace
    else if (c.li !== void 0 && c.ld !== void 0) {
      json.checkList(elem);
      // Should check the list element matches c.ld
      elem[key] = c.li;
    }

    // List insert
    else if (c.li !== void 0) {
      json.checkList(elem);
      // @ts-expect-error
      elem.splice(key, 0, c.li);
    }

    // List delete
    else if (c.ld !== void 0) {
      json.checkList(elem);
      // **** START CUSTOM CHANGE ****
      // If ldCheck flag is set, verify the element matches before deleting.
      // This prevents deleting the wrong element when the document has been modified
      // by concurrent operations (e.g., stale client cleanup operations).
      if (c.ldCheck) {
        const elementToDelete = elem[key];
        if (JSON.stringify(elementToDelete) !== JSON.stringify(c.ld)) {
          // Element doesn't match - skip deletion. This can happen when:
          // 1. A stale client tries to delete ops that have been modified by other clients
          // 2. The operation is based on outdated document state
          // Silently ignore to prevent corrupting the document.

          console.warn("[json0] ldCheck: Skipping list delete due to element mismatch", {
            path: c.p.join("."),
            index: key,
            expectedElement: c.ld,
            actualElement: elementToDelete,
          });
          continue;
        }
      }
      // **** END CUSTOM CHANGE ****
      // @ts-expect-error
      elem.splice(key, 1);
    }

    // List move
    else if (c.lm !== void 0) {
      json.checkList(elem);
      if (c.lm != key) {
        const e = elem[key];
        // Remove it...
        // @ts-expect-error
        elem.splice(key, 1);
        // And insert it back.
        // @ts-expect-error
        elem.splice(c.lm, 0, e);
      }
    }

    // Object insert / replace
    else if (c.oi !== void 0) {
      json.checkObj(elem);

      // Should check that elem[key] == c.od
      elem[key] = c.oi;
    }

    // Object delete
    else if (c.od !== void 0) {
      json.checkObj(elem);

      // Should check that elem[key] == c.od
      delete elem[key];
    }

    // **** START CUSTOM CHANGE ****
    // Object insert default (only insert if path doesn't exist)
    else if (c.oid !== void 0) {
      json.checkObj(elem);

      // Only set if the key doesn't already exist
      if (elem[key] === void 0) {
        elem[key] = c.oid;
      }
      // If key exists, this is a no-op
      // *** END CUSTOM CHANGE ***
    } else {
      throw new Error("invalid / missing instruction in op");
    }
  }

  return container.data;
};

// Helper to break an operation up into a bunch of small ops.
json.shatter = function (op) {
  const results = [];
  for (let i = 0; i < op.length; i++) {
    results.push([op[i]]);
  }
  return results;
};

// Helper for incrementally applying an operation to a snapshot. Calls yield
// after each op component has been applied.
json.incrementalApply = function (snapshot, op, _yield) {
  for (let i = 0; i < op.length; i++) {
    const smallOp = [op[i]];
    snapshot = json.apply(snapshot, smallOp);
    // I'd just call this yield, but thats a reserved keyword. Bah!
    _yield(smallOp, snapshot);
  }

  return snapshot;
};

// Checks if two paths, p1 and p2 match.
const pathMatches = (json.pathMatches = function (p1, p2, ignoreLast = undefined) {
  if (p1.length != p2.length) return false;

  for (let i = 0; i < p1.length; i++) {
    if (p1[i] !== p2[i] && (!ignoreLast || i !== p1.length - 1)) return false;
  }

  return true;
});

json.append = function (dest, c) {
  c = clone(c);

  if (dest.length === 0) {
    dest.push(c);
    return;
  }

  const last = dest[dest.length - 1];

  // convert old string ops to use subtype for backwards compatibility
  if ((c.si != null || c.sd != null) && (last.si != null || last.sd != null)) {
    convertFromText(c);
    convertFromText(last);
  }

  if (pathMatches(c.p, last.p)) {
    // handle subtype ops
    if (c.t && last.t && c.t === last.t && subtypes[c.t]) {
      last.o = subtypes[c.t].compose(last.o, c.o);

      // convert back to old string ops
      if (c.si != null || c.sd != null) {
        const p = c.p;
        for (let i = 0; i < last.o.length - 1; i++) {
          c.o = [last.o.pop()];
          c.p = p.slice();
          convertToText(c);
          dest.push(c);
        }

        convertToText(last);
      }
    } else if (last.na != null && c.na != null) {
      dest[dest.length - 1] = { p: last.p, na: last.na + c.na };
    } else if (last.li !== undefined && c.li === undefined && c.ld === last.li) {
      // insert immediately followed by delete becomes a noop.
      if (last.ld !== undefined) {
        // leave the delete part of the replace
        delete last.li;
      } else {
        dest.pop();
      }
    } else if (
      last.od !== undefined &&
      last.oi === undefined &&
      c.oi !== undefined &&
      c.od === undefined
    ) {
      last.oi = c.oi;
    } else if (last.oi !== undefined && c.od !== undefined) {
      // The last path component inserted something that the new component deletes (or replaces).
      // Just merge them.
      if (c.oi !== undefined) {
        last.oi = c.oi;
      } else if (last.od !== undefined) {
        delete last.oi;
      } else {
        // An insert directly followed by a delete turns into a no-op and can be removed.
        dest.pop();
      }
    } else if (c.lm !== undefined && c.p[c.p.length - 1] === c.lm) {
      // don't do anything
    } else {
      dest.push(c);
    }
  } else {
    // convert string ops back
    if ((c.si != null || c.sd != null) && (last.si != null || last.sd != null)) {
      convertToText(c);
      convertToText(last);
    }

    dest.push(c);
  }
};

json.compose = function (op1, op2) {
  json.checkValidOp(op1);
  json.checkValidOp(op2);

  const newOp = clone(op1);

  for (let i = 0; i < op2.length; i++) {
    json.append(newOp, op2[i]);
  }

  return newOp;
};

json.normalize = function (op) {
  const newOp = [];

  op = isArray(op) ? op : [op];

  for (let i = 0; i < op.length; i++) {
    const c = op[i];
    if (c.p == null) c.p = [];

    json.append(newOp, c);
  }

  return newOp;
};

// Returns the common length of the paths of ops a and b
json.commonLengthForOps = function (a, b) {
  let alen = a.p.length;
  let blen = b.p.length;
  if (a.na != null || a.t) alen++;

  if (b.na != null || b.t) blen++;

  if (alen === 0) return -1;
  if (blen === 0) return null;

  alen--;
  blen--;

  for (let i = 0; i < alen; i++) {
    const p = a.p[i];
    if (i >= blen || p !== b.p[i]) return null;
  }

  return alen;
};

// Returns true if an op can affect the given path
json.canOpAffectPath = function (op, path) {
  return json.commonLengthForOps({ p: path }, op) != null;
};

// transform c so it applies to a document with otherC applied.
json.transformComponent = function (dest, c, otherC, type) {
  c = clone(c);

  const common = json.commonLengthForOps(otherC, c);
  const common2 = json.commonLengthForOps(c, otherC);
  let cplength = c.p.length;
  let otherCplength = otherC.p.length;

  if (c.na != null || c.t) cplength++;

  if (otherC.na != null || otherC.t) otherCplength++;

  // if c is deleting something, and that thing is changed by otherC, we need to
  // update c to reflect that change for invertibility.
  if (common2 != null && otherCplength > cplength && c.p[common2] == otherC.p[common2]) {
    if (c.ld !== void 0) {
      var oc = clone(otherC);
      oc.p = oc.p.slice(cplength);
      c.ld = json.apply(clone(c.ld), [oc]);
    } else if (c.od !== void 0) {
      var oc = clone(otherC);
      oc.p = oc.p.slice(cplength);
      c.od = json.apply(clone(c.od), [oc]);
    }
  }

  if (common != null) {
    const commonOperand = cplength == otherCplength;

    // backward compatibility for old string ops
    var oc = otherC;
    if ((c.si != null || c.sd != null) && (otherC.si != null || otherC.sd != null)) {
      convertFromText(c);
      oc = clone(otherC);
      convertFromText(oc);
    }

    // handle subtype ops
    if (oc.t && subtypes[oc.t]) {
      if (c.t && c.t === oc.t) {
        const res = subtypes[c.t].transform(c.o, oc.o, type);

        // convert back to old string ops
        if (c.si != null || c.sd != null) {
          var p = c.p;
          for (let i = 0; i < res.length; i++) {
            c.o = [res[i]];
            c.p = p.slice();
            convertToText(c);
            json.append(dest, c);
          }
        } else if (!isArray(res) || res.length > 0) {
          c.o = res;
          json.append(dest, c);
        }

        return dest;
      }
    }

    // transform based on otherC
    else if (otherC.na !== void 0) {
      // this case is handled below
    } else if (otherC.li !== void 0 && otherC.ld !== void 0) {
      if (otherC.p[common] === c.p[common]) {
        // noop

        if (!commonOperand) {
          return dest;
        }
        if (c.ld !== void 0) {
          // we're trying to delete the same element, -> noop
          if (c.li !== void 0 && type === "left") {
            // we're both replacing one element with another. only one can survive
            c.ld = clone(otherC.li);
          } else {
            return dest;
          }
        }
      }
    } else if (otherC.li !== void 0) {
      if (
        c.li !== void 0 &&
        c.ld === undefined &&
        commonOperand &&
        c.p[common] === otherC.p[common]
      ) {
        // in li vs. li, left wins.
        if (type === "right") c.p[common]++;
      } else if (otherC.p[common] <= c.p[common]) {
        c.p[common]++;
      }

      if (c.lm !== void 0) {
        if (commonOperand) {
          // otherC edits the same list we edit
          if (otherC.p[common] <= c.lm) c.lm++;
          // changing c.from is handled above.
        }
      }
    } else if (otherC.ld !== void 0) {
      if (c.lm !== void 0) {
        if (commonOperand) {
          if (otherC.p[common] === c.p[common]) {
            // they deleted the thing we're trying to move
            return dest;
          }
          // otherC edits the same list we edit
          var p = otherC.p[common];
          var from = c.p[common];
          var to = c.lm;
          if (p < to || (p === to && from < to)) c.lm--;
        }
      }

      if (otherC.p[common] < c.p[common]) {
        c.p[common]--;
      } else if (otherC.p[common] === c.p[common]) {
        if (otherCplength < cplength) {
          // we're below the deleted element, so -> noop
          return dest;
        }
        if (c.ld !== void 0) {
          if (c.li !== void 0) {
            // we're replacing, they're deleting. we become an insert.
            delete c.ld;
          } else {
            // we're trying to delete the same element, -> noop
            return dest;
          }
        }
      }
    } else if (otherC.lm !== void 0) {
      if (c.lm !== void 0 && cplength === otherCplength) {
        // lm vs lm, here we go!
        var from = c.p[common];
        var to = c.lm;
        const otherFrom = otherC.p[common];
        const otherTo = otherC.lm;
        if (otherFrom !== otherTo) {
          // if otherFrom == otherTo, we don't need to change our op.

          // where did my thing go?
          if (from === otherFrom) {
            // they moved it! tie break.
            if (type === "left") {
              c.p[common] = otherTo;
              if (from === to)
                // ugh
                c.lm = otherTo;
            } else {
              return dest;
            }
          } else {
            // they moved around it
            if (from > otherFrom) c.p[common]--;
            if (from > otherTo) c.p[common]++;
            else if (from === otherTo) {
              if (otherFrom > otherTo) {
                c.p[common]++;
                if (from === to)
                  // ugh, again
                  c.lm++;
              }
            }

            // step 2: where am i going to put it?
            if (to > otherFrom) {
              c.lm--;
            } else if (to === otherFrom) {
              if (to > from) c.lm--;
            }
            if (to > otherTo) {
              c.lm++;
            } else if (to === otherTo) {
              // if we're both moving in the same direction, tie break
              if ((otherTo > otherFrom && to > from) || (otherTo < otherFrom && to < from)) {
                if (type === "right") c.lm++;
              } else if (to > from) c.lm++;
              else if (to === otherFrom) c.lm--;
            }
          }
        }
      } else if (c.li !== void 0 && c.ld === undefined && commonOperand) {
        // li
        var from = otherC.p[common];
        var to = otherC.lm;
        p = c.p[common];
        if (p > from) c.p[common]--;
        if (p > to) c.p[common]++;
      } else {
        // ld, ld+li, si, sd, na, oi, od, oi+od, any li on an element beneath
        // the lm
        //
        // i.e. things care about where their item is after the move.
        var from = otherC.p[common];
        var to = otherC.lm;
        p = c.p[common];
        if (p === from) {
          c.p[common] = to;
        } else {
          if (p > from) c.p[common]--;
          if (p > to) c.p[common]++;
          else if (p === to && from > to) c.p[common]++;
        }
      }
    } else if (otherC.oi !== void 0 && otherC.od !== void 0) {
      if (c.p[common] === otherC.p[common]) {
        if (c.oi !== void 0 && commonOperand) {
          // we inserted where someone else replaced
          if (type === "right") {
            // left wins
            return dest;
          }
          // we win, make our op replace what they inserted
          c.od = otherC.oi;
        } else {
          // -> noop if the other component is deleting the same object (or any parent)
          return dest;
        }
      }
    } else if (otherC.oi !== void 0) {
      if (c.oi !== void 0 && c.p[common] === otherC.p[common]) {
        // left wins if we try to insert at the same place
        if (type === "left") {
          json.append(dest, { p: c.p, od: otherC.oi });
        } else {
          return dest;
        }
      }
    } else if (otherC.od !== void 0) {
      if (c.p[common] == otherC.p[common]) {
        if (!commonOperand) return dest;
        if (c.oi !== void 0) {
          delete c.od;
        } else {
          return dest;
        }
      }
    }
  }

  json.append(dest, c);
  return dest;
};

json.createPresence = function (presenceData) {
  return presenceData;
};

json.comparePresence = function (pres1, pres2) {
  return JSON.stringify(pres1) === JSON.stringify(pres2);
};

// var transformPosition = function(cursor, op, isOwnOp) {
//   var cursor = clone(cursor);
//
//   var opIsAncestor = cursor.length >= op.p.length; // true also if op is self
//   var opIsSibling = cursor.length === op.p.length; // true also if op is self
//   var opIsAncestorSibling = cursor.length >= op.p.length; // true also if op is self or sibling of self
//   var equalUpTo = -1;
//   for (var i = 0; i < op.p.length; i++) {
//     if (op.p[i] !== cursor[i]) {
//       opIsAncestor = false;
//       if (i < op.p.length - 1) {
//         opIsSibling = false;
//         opIsAncestorSibling = false;
//       }
//     }
//     if (equalUpTo === i - 1 && op.p[i] === cursor[i]) {
//       equalUpTo += 1;
//     }
//   }
//
//   if (opIsSibling) {
//     if (op.sd) {
//       cursor[cursor.length - 1] = text.transformCursor(
//         cursor[cursor.length - 1],
//         [{ p: op.p[op.p.length - 1], d: op.sd }],
//         isOwnOp ? 'right' : 'left'
//       );
//     }
//     if (op.si) {
//       cursor[cursor.length - 1] = text.transformCursor(
//         cursor[cursor.length - 1],
//         [{ p: op.p[op.p.length - 1], i: op.si }],
//         isOwnOp ? 'right' : 'left'
//       );
//     }
//   }
//
//   if (opIsAncestor) {
//     if (op.lm !== undefined) {
//       cursor[equalUpTo] = op.lm;
//     }
//     if (op.od && op.oi) {
//       cursor = op.p.slice(0, op.p.length);
//     } else if (op.od) {
//       cursor = op.p.slice(0, op.p.length - 1);
//     } else if (op.ld && op.li) {
//       cursor = op.p.slice(0, op.p.length);
//     } else if (op.ld) {
//       cursor = op.p.slice(0, op.p.length - 1);
//     }
//   }
//
//   if (opIsAncestorSibling) {
//     var lastPathIdx = op.p.length - 1;
//     if (
//       !opIsAncestor &&
//       op.ld &&
//       !op.li &&
//       op.p[lastPathIdx] < cursor[lastPathIdx]
//     ) {
//       cursor[lastPathIdx] -= 1;
//     } else if (!op.ld && op.li && op.p[lastPathIdx] <= cursor[lastPathIdx]) {
//       cursor[lastPathIdx] += 1;
//     }
//
//     // if move item in list from after to before
//     if (
//       !opIsAncestor &&
//       op.lm !== undefined &&
//       op.p[lastPathIdx] > cursor[lastPathIdx] &&
//       op.lm <= cursor[lastPathIdx]
//     ) {
//       cursor[lastPathIdx] += 1;
//       // if move item in list from before to after
//     } else if (
//       !opIsAncestor &&
//       op.lm !== undefined &&
//       op.p[lastPathIdx] < cursor[lastPathIdx] &&
//       op.lm >= cursor[lastPathIdx]
//     ) {
//       cursor[lastPathIdx] -= 1;
//     }
//   }
//
//   return cursor;
// };
//
// json.transformCursor = function(cursor, op, isOwnOp) {
//   for (var i = 0; i < op.length; i++) {
//     cursor = transformPosition(cursor, op[i], isOwnOp);
//   }
//   return cursor;
// };
//

json.transformPresence = function (presence, op, isOwnOp) {
  // Don't transform path-only presence objects.
  if (!presence.t) return presence;

  for (let i = 0; i < op.length; i++) {
    const c = op[i];

    // convert old string ops to use subtype for backwards compatibility
    if (c.si != null || c.sd != null) {
      convertFromText(c);
    }

    // Transform against subtype ops.
    if (c.t && c.t === presence.t && json.pathMatches(c.p, presence.p)) {
      presence = {
        ...presence,
        s: subtypes[presence.t].transformPresence(presence.s, [c], isOwnOp),
      };
    }

    // convert back to old string ops
    if (c.t === "text0") {
      convertToText(c);
    }

    // TODO transform against non-subtype ops.
  }
  return presence;
};

bootstrapTransform(json, json.transformComponent, json.checkValidOp, json.append);

/**
 * Register a subtype for string operations, using the text0 type.
 */
import text from "./text0";

json.registerSubtype(text);

export default { type: json };
